import styled from 'styled-components';
import { vars } from '../../../../theme';
import { applyOpacity } from '../../../../utils/color.utils';
import spacing from '../../../../styles/spacing';
import colors from '../../../../styles/colors';
import { HBSideNavWidget } from '../HBSideNavWidget';

const invertedPrimary = vars.colors.text.invertedPrimary;

export const StyledWidget = styled(HBSideNavWidget)<{
    $selected?: boolean;
}>`
    flex-direction: row;
    align-items: center;
    padding-right: ${spacing[8]};
    gap: ${spacing[8]};
    cursor: pointer;
    transition: all 0.2s ease-in-out;

    ${({ $selected }) =>
        !$selected &&
        `
        &:hover {
            border-color: ${applyOpacity(invertedPrimary, 30)};
            background-color: ${applyOpacity(invertedPrimary, 12)};
        }
    `}

    ${({ $selected }) =>
        $selected &&
        `
        border-color: ${applyOpacity(invertedPrimary, 72)};
        background-color: ${applyOpacity(invertedPrimary, 14)};
    `}
`;

export const WidgetPrefixWrapper = styled.div`
    display: flex;
    align-items: center;
    flex-shrink: 0;
`;

export const ContentAndActionContainer = styled.div<{ $isExpanded: boolean }>`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${spacing[4]};
    flex: 1;
    min-width: 0;
    overflow: hidden;
    transition: max-height 100ms ease-in-out, opacity 100ms ease-in-out;
    max-height: ${({ $isExpanded }) => ($isExpanded ? '500px' : '0')};
    opacity: ${({ $isExpanded }) => ($isExpanded ? '1' : '0')};
`;

export const PrefixAndContentContainer = styled.div`
    display: flex;
    align-items: center;
    gap: ${spacing[8]};
    flex: 1 0 0;
    min-width: 0;
`;

export const ContentArea = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${spacing[4]};
    flex: 1 0 0;
    min-width: 0;
    overflow: hidden;
    min-width: 150px;
`;

export const TitleRow = styled.div`
    display: flex;
    align-items: center;
    gap: ${spacing[6]};
    white-space: nowrap;
    overflow: hidden;
`;

export const IconWrapper = styled.div<{ $selected?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    line-height: 0;

    i {
        line-height: 0;
    }

    svg * {
        width: 16px;
        height: 16px;
        fill: ${({ $selected }) =>
            $selected ? invertedPrimary : colors.neutral400};
    }
`;

export const ArrowIconWrapper = styled.div<{ $selected?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    line-height: 0;

    svg * {
        width: 16px;
        height: 16px;
        fill: ${({ $selected }) =>
            $selected ? invertedPrimary : colors.neutral400};
    }
`;
